// extracted by mini-css-extract-plugin
export default {"container":"BasicInformation_container__sTM4f","header":"BasicInformation_header__sb+T9","text":"BasicInformation_text__ktet4"};